export default "__VITE_ASSET__DMnLvrFz__"